import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const updateUserNameAction = {
    ...operations,
    ...selectors,
};

export {
    updateUserNameAction,
};
export default {
    [namespace]: reducer,
};
